<template>
  <b-dropdown class="dropdown-form" ref="dropdown" right
              v-bind:class="{'color-button': (!listingStatusDefault) || (listingOptions.length > 0) || (listingEvents.length > 0) || (minSqft) || (maxSqft) || (stories !== 'Any') || (minLotSize) || (maxLotSize) || (insideFeatures.length > 0) || (outsideFeatures.length > 0) || (heatingCooling.length > 0) || (parking.length > 0) || (minHomeAge) || (maxHomeAge) || (garage !== 'Any') || (lotView.length > 0) || (communityAmenities.length > 0) || (minHOA > 0) || (maxHOA > 0)}">
    <template slot="button-content">
      More Filters
    </template>
    <b-dropdown-form>
      <div class="container-fluid">

        <!-- listing status -->
        <div class="row dropdown-row">
          <div class="col left-dropdown-col">
            <h5>Listing Status</h5>
          </div>
        </div>
        <div class="row dropdown-row">
          <div class="col left-dropdown-col">
            <div class="form-check">
              <input type="checkbox" class="form-check-input" value="Active" v-model="listingStatus">
              <label class="form-check-label">For Sale<div class="color-box" style="background-color: #9a0d48;"></div></label>
            </div>
            <div class="form-check">
              <input type="checkbox" class="form-check-input" value="Closed" v-model="listingStatus">
              <label class="form-check-label">Sold<div class="color-box" style="background-color: #999999;"></div></label>
            </div>
          </div>
          <div class="col right-dropdown-col">
            <div class="form-check">
              <input type="checkbox" class="form-check-input" value="Rental" v-model="listingStatus">
              <label class="form-check-label">Rental<div class="color-box" style="background-color: #662d91;"></div></label>
            </div>
            <div class="form-check">
              <input type="checkbox" class="form-check-input" value="Pending" v-model="listingStatus">
              <label class="form-check-label">Pending/Contingent<div class="color-box" style="background-color: #363e4a;"></div></label>
            </div>
          </div>
        </div>
        <hr>

        <!-- listing events -->
        <div class="row dropdown-row">
          <div class="col left-dropdown-col">
            <h5>Listing Events</h5>
          </div>
        </div>
        <div class="row dropdown-row">
          <div class="col left-dropdown-col">
            <div class="form-check">
              <input type="checkbox" class="form-check-input" value="open houses" v-model="listingEvents">
              <label class="form-check-label">Open Houses<div class="color-box" style="background-color: #009244;"></div></label>
            </div>
          </div>
          <!-- TODO: Reintroduce when functionality restored
          <div class="col right-dropdown-col">
            <div class="form-check">
              <input type="checkbox" class="form-check-input" value="price reduced" v-model="listingEvents">
              <label class="form-check-label">Price Reduced</label>
            </div>
          </div>
          -->
        </div>
        <hr>

        <!-- listing options -->
        <div class="row dropdown-row">
          <div class="col left-dropdown-col">
            <h5>Listing Options</h5>
          </div>
        </div>
        <div class="row dropdown-row">
          <div class="col left-dropdown-col">
            <div class="form-check">
              <input type="checkbox" class="form-check-input" value="new construction" v-model="listingOptions">
              <label class="form-check-label">New Construction</label>
            </div>
          </div>
          <div class="col right-dropdown-col">
            <div class="form-check">
              <input type="checkbox" class="form-check-input" value="foreclosure" v-model="listingOptions">
              <label class="form-check-label">Foreclosure</label>
            </div>
          </div>
        </div>
        <hr>

        <!-- sq ft -->
        <div class="row dropdown-row">
          <div class="col left-dropdown-col">
            <h5>Square Feet</h5>
          </div>
        </div>
        <div class="row dropdown-row">
          <div class="col right-dropdown-col">
            <input class="form-control HOA-input" type="search" placeholder="Min" v-model="minSqft" @focus="showSqftOptions = true">
          </div>
          <h6 class="d-inline middle-dash">-</h6>
          <div class="col left-dropdown-col">
            <input class="form-control HOA-input" type="search" placeholder="Max" v-model="maxSqft" @focus="showSqftOptions = true">
          </div>
        </div>
        <div class="row" v-if="showSqftOptions">
          <div class="col">
            <p v-for="sqft in minSqfts" v-bind:key="sqft" class="no-margin HOA-select text-center" v-on:click="updateMinSqft(sqft)">{{ sqft.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}</p>
          </div>
          <div class="col">
            <p v-for="sqft in maxSqfts" v-bind:key="sqft" class="no-margin HOA-select text-center" v-on:click="updateMaxSqft(sqft)">{{ sqft.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}</p>
          </div>
        </div>
        <hr>

        <!-- home stories -->
        <div class="row dropdown-row">
          <div class="col left-dropdown-col">
            <h5>Home Stories</h5>
          </div>
        </div>
        <div class="row dropdown-row">
          <div class="form-check form-check-inline">
            <input type="radio" class="form-check-input" value="Any" v-model="stories">
            <label class="form-check-label">Any</label>
          </div>
          <div class="form-check form-check-inline">
            <input type="radio" class="form-check-input" value="Single" v-model="stories">
            <label class="form-check-label">Single</label>
          </div>
          <div class="form-check form-check-inline">
            <input type="radio" class="form-check-input" value="Multi" v-model="stories">
            <label class="form-check-label">Multi</label>
          </div>
        </div>
        <hr>

        <!-- lot size -->
        <div class="row dropdown-row">
          <div class="col left-dropdown-col">
            <h5>Lot Size</h5>
          </div>
        </div>
        <div class="row dropdown-row">
          <div class="col right-dropdown-col">
            <input class="form-control HOA-input" type="search" placeholder="No Min" v-model="minLotSize" @focus="showLotSizes = true" readonly>
          </div>
          <h6 class="d-inline middle-dash">-</h6>
          <div class="col left-dropdown-col">
            <input class="form-control HOA-input" type="search" placeholder="No Max" v-model="maxLotSize" @focus="showLotSizes = true" readonly>
          </div>
        </div>
        <div class="row" v-if="showLotSizes">
          <div class="col">
            <p class="no-margin HOA-select text-center" v-on:click="updateMinLotSize(null)">No Min</p>
            <p v-for="size in minLotSizes" v-bind:key="size.id" class="no-margin HOA-select text-center" v-on:click="updateMinLotSize(size.desc)">{{ size.desc.replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}</p>
          </div>
          <div class="col">
            <p class="no-margin HOA-select text-center" v-on:click="updateMaxLotSize(null)">No Max</p>
            <p v-for="size in maxLotSizes" v-bind:key="size.id" class="no-margin HOA-select text-center" v-on:click="updateMaxLotSize(size.desc)">{{ size.desc.replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}</p>
          </div>
        </div>
        <hr>

        <!-- inside features -->
        <div class="row dropdown-row">
          <div class="col left-dropdown-col">
            <h5>Inside Features</h5>
          </div>
        </div>
        <div class="row dropdown-row">
          <div class="col left-dropdown-col">
            <div class="form-check">
              <input type="checkbox" class="form-check-input" value="hardwood floors" v-model="insideFeatures">
              <label class="form-check-label">Hardwood Floors</label>
            </div>
            <div class="form-check">
              <input type="checkbox" class="form-check-input" value="fireplace" v-model="insideFeatures">
              <label class="form-check-label">Fireplace</label>
            </div>
            <div class="form-check">
              <input type="checkbox" class="form-check-input" value="disability features" v-model="insideFeatures">
              <label class="form-check-label">Disability Features</label>
            </div>
          </div>
          <div class="col right-dropdown-col">
            <div class="form-check">
              <input type="checkbox" class="form-check-input" value="basement" v-model="insideFeatures">
              <label class="form-check-label">Basement</label>
            </div>
            <div class="form-check">
              <input type="checkbox" class="form-check-input" value="dining room" v-model="insideFeatures">
              <label class="form-check-label">Din Room</label>
            </div>
            <div class="form-check">
              <input type="checkbox" class="form-check-input" value="office" v-model="insideFeatures">
              <label class="form-check-label">Office</label>
            </div>
          </div>
        </div>
        <hr>

        <!-- outside features -->
        <div class="row dropdown-row">
          <div class="col left-dropdown-col">
            <h5>Outside Features</h5>
          </div>
        </div>
        <div class="row dropdown-row">
          <div class="col left-dropdown-col">
            <div class="form-check">
              <input type="checkbox" class="form-check-input" value="fenced yard" v-model="outsideFeatures">
              <label class="form-check-label">Fenced Yard</label>
            </div>
            <div class="form-check">
              <input type="checkbox" class="form-check-input" value="hot tub" v-model="outsideFeatures">
              <label class="form-check-label">Spa/Hot Tub</label>
            </div>
            <div class="form-check">
              <input type="checkbox" class="form-check-input" value="3 season porch" v-model="outsideFeatures">
              <label class="form-check-label">3 Season Porch</label>
            </div>
            <div class="form-check">
              <input type="checkbox" class="form-check-input" value="attached garage" v-model="outsideFeatures">
              <label class="form-check-label">Attached Garage</label>
            </div>
          </div>
          <div class="col right-dropdown-col">
            <div class="form-check">
              <input type="checkbox" class="form-check-input" value="pool" v-model="outsideFeatures">
              <label class="form-check-label">Pool</label>
            </div>
            <div class="form-check">
              <input type="checkbox" class="form-check-input" value="porch/deck" v-model="outsideFeatures">
              <label class="form-check-label">Porch/Deck</label>
            </div>
            <div class="form-check">
              <input type="checkbox" class="form-check-input" value="4 season porch" v-model="outsideFeatures">
              <label class="form-check-label">4 Season Porch</label>
            </div>
          </div>
        </div>
        <hr>

        <!-- heating and cooling -->
        <div class="row dropdown-row">
          <div class="col left-dropdown-col">
            <h5>Heating/Cooling</h5>
          </div>
        </div>
        <div class="row dropdown-row">
          <div class="col left-dropdown-col">
            <div class="form-check">
              <input type="checkbox" class="form-check-input" value="central" v-model="heatingCooling">
              <label class="form-check-label">Central Air</label>
            </div>
            <div class="form-check">
              <input type="checkbox" class="form-check-input" value="forced air" v-model="heatingCooling">
              <label class="form-check-label">Forced Air</label>
            </div>
          </div>
          <div class="col right-dropdown-col">
            <div class="form-check">
              <input type="checkbox" class="form-check-input" value="central heat" v-model="heatingCooling">
              <label class="form-check-label">Central Heat</label>
            </div>
          </div>
        </div>
        <hr>

        <!-- parking -->
        <div class="row dropdown-row">
          <div class="col left-dropdown-col">
            <h5>Parking</h5>
          </div>
        </div>
        <div class="row dropdown-row">
          <div class="col left-dropdown-col">
            <div class="form-check">
              <input type="checkbox" class="form-check-input" value="garage" v-model="parking">
              <label class="form-check-label">Garage</label>
            </div>
            <div class="form-check">
              <input type="checkbox" class="form-check-input" value="street" v-model="parking">
              <label class="form-check-label">Street</label>
            </div>
          </div>
          <div class="col right-dropdown-col">
            <div class="form-check">
              <input type="checkbox" class="form-check-input" value="assigned" v-model="parking">
              <label class="form-check-label">Assigned</label>
            </div>
          </div>
        </div>
        <hr>

        <!-- home age -->
        <div class="row dropdown-row">
          <div class="col left-dropdown-col">
            <h5>Home Age</h5>
          </div>
        </div>
        <div class="row dropdown-row">
          <div class="col right-dropdown-col">
            <input class="form-control HOA-input" type="search" placeholder="No Min" v-model="minHomeAge" @focus="showHomeAges = true">
          </div>
          <h6 class="d-inline middle-dash">-</h6>
          <div class="col left-dropdown-col">
            <input class="form-control HOA-input" type="search" placeholder="No Max" v-model="maxHomeAge" @focus="showHomeAges = true">
          </div>
        </div>
        <div class="row" v-if="showHomeAges">
          <div class="col">
            <p v-for="age in minHomeAges" v-bind:key="age.id" class="no-margin HOA-select text-center" v-on:click="updateMinHomeAge(age.id)">{{ age.desc.replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}</p>
          </div>
          <div class="col">
            <p v-for="age in maxHomeAges" v-bind:key="age.id" class="no-margin HOA-select text-center" v-on:click="updateMaxHomeAge(age.id)">{{ age.desc.replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}</p>
          </div>
        </div>
        <hr>

        <!-- garage -->
        <div class="row dropdown-row">
          <div class="col left-dropdown-col">
            <h5>Garage</h5>
          </div>
        </div>
        <div class="row dropdown-row">
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio" value="Any" v-model="garage">
            <label class="form-check-label">Any</label>
          </div>
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio" value="1" v-model="garage">
            <label class="form-check-label">1+</label>
          </div>
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio" value="2" v-model="garage">
            <label class="form-check-label">2+</label>
          </div>
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio" value="3" v-model="garage">
            <label class="form-check-label">3+</label>
          </div>
        </div>
        <hr>

        <!-- parking -->
        <!-- <div class="row dropdown-row">
          <div class="col left-dropdown-col">
            <h5>Parking</h5>
          </div>
        </div>
        <div class="row dropdown-row">
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="checkbox" value="garage" v-model="parking">
            <label class="form-check-label">Garage</label>
          </div>
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="checkbox" value="assigned" v-model="parking">
            <label class="form-check-label">Assigned</label>
          </div>
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="checkbox" value="street" v-model="parking">
            <label class="form-check-label">Street</label>
          </div>
        </div>
        <hr> -->

        <!-- lot view -->
        <div class="row dropdown-row">
          <div class="col left-dropdown-col">
            <h5>Lot/View</h5>
          </div>
        </div>
        <div class="row dropdown-row">
          <div class="col left-dropdown-col">
            <div class="form-check">
              <input type="checkbox" class="form-check-input" value="waterfront" v-model="lotView">
              <label class="form-check-label">Waterfront</label>
            </div>
            <div class="form-check">
              <input type="checkbox" class="form-check-input" value="cul-de-sac" v-model="lotView">
              <label class="form-check-label">Cul-de-sac</label>
            </div>
            <div class="form-check">
              <input type="checkbox" class="form-check-input" value="golf course" v-model="lotView">
              <label class="form-check-label">Golf Course</label>
            </div>
            <div class="form-check">
              <input type="checkbox" class="form-check-input" value="corner lot" v-model="lotView">
              <label class="form-check-label">Corner Lot</label>
            </div>
          </div>
          <div class="col right-dropdown-col">
            <div class="form-check">
              <input type="checkbox" class="form-check-input" value="hill/mtn" v-model="lotView">
              <label class="form-check-label">Hill/Mtn</label>
            </div>
            <div class="form-check">
              <input type="checkbox" class="form-check-input" value="ocean" v-model="lotView">
              <label class="form-check-label">Ocean</label>
            </div>
            <div class="form-check">
              <input type="checkbox" class="form-check-input" value="lake" v-model="lotView">
              <label class="form-check-label">Lake</label>
            </div>
            <div class="form-check">
              <input type="checkbox" class="form-check-input" value="river" v-model="lotView">
              <label class="form-check-label">River</label>
            </div>
          </div>
        </div>
        <hr>

        <!-- community amenities -->
        <div class="row dropdown-row">
          <div class="col left-dropdown-col">
            <h5>Community Amenities</h5>
          </div>
        </div>
        <div class="row dropdown-row">
          <div class="col left-dropdown-col">
            <div class="form-check">
              <input type="checkbox" class="form-check-input" value="pools" v-model="communityAmenities">
              <label class="form-check-label">Pool(s)</label>
            </div>
            <div class="form-check">
              <input type="checkbox" class="form-check-input" value="hot tub" v-model="communityAmenities">
              <label class="form-check-label">Hot Tub</label>
            </div>
            <div class="form-check">
              <input type="checkbox" class="form-check-input" value="sauna" v-model="communityAmenities">
              <label class="form-check-label">Sauna</label>
            </div>
            <div class="form-check">
              <input type="checkbox" class="form-check-input" value="boat facilities" v-model="communityAmenities">
              <label class="form-check-label">Boat Facilities</label>
            </div>
            <div class="form-check">
              <input type="checkbox" class="form-check-input" value="hoa" v-model="communityAmenities">
              <label class="form-check-label">HOA</label>
            </div>
          </div>
          <div class="col right-dropdown-col">
            <div class="form-check">
              <input type="checkbox" class="form-check-input" value="gym" v-model="communityAmenities">
              <label class="form-check-label">Gym</label>
            </div>
            <div class="form-check">
              <input type="checkbox" class="form-check-input" value="senior community" v-model="communityAmenities">
              <label class="form-check-label">Senior Community</label>
            </div>
            <div class="form-check">
              <input type="checkbox" class="form-check-input" value="golf course" v-model="communityAmenities">
              <label class="form-check-label">Golf Course</label>
            </div>
            <div class="form-check">
              <input type="checkbox" class="form-check-input" value="tennis courts" v-model="communityAmenities">
              <label class="form-check-label">Tennis Court(s)</label>
            </div>
          </div>
        </div>
        <hr>

        <!-- hoa expense -->
        <div class="row dropdown-row">
          <div class="col left-dropdown-col">
            <h5>HOA Expense</h5>
          </div>
        </div>
        <div class="row dropdown-row">
          <div class="col right-dropdown-col">
            <money class="form-control HOA-input" type="search" v-model="minHOA" v-bind="money" @focus.native="showHOAPrices = true"></money>
          </div>
          <h6 class="d-inline middle-dash">-</h6>
          <div class="col left-dropdown-col">
            <money class="form-control HOA-input" type="search" v-model="maxHOA" v-bind="money" @focus.native="showHOAPrices = true"></money>
          </div>
        </div>
        <div class="row" v-if="showHOAPrices">
          <div class="col">
            <p v-for="HOA in minHOAs" v-bind:key="HOA" class="no-margin HOA-select text-center" v-on:click="updateMinHOA(HOA)">${{ HOA.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}</p>
          </div>
          <div class="col">
            <p v-for="HOA in maxHOAs" v-bind:key="HOA" class="no-margin HOA-select text-center" v-on:click="updateMaxHOA(HOA)">${{ HOA.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}</p>
          </div>
        </div>
      </div>
    </b-dropdown-form>
  </b-dropdown>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import mixins from '../../../Mixins.js'
import { Money } from 'v-money'

export default {
  data () {
    return {
      sqfts: [500, 750, 1000, 1250, 1500, 1750, 2000, 2250, 2500, 2750, 3000, 3250, 3500, 3750, 4000, 5000, 7000],
      showSqftOptions: false,
      lotsizes: [{id: 100, desc: '5,000 ft²'}, {id: 200, desc: '7,500 ft²'}, {id: 300, desc: '0.25 acres'}, {id: 400, desc: '0.5 acres'}, {id: 500, desc: '1 acre'}, {id: 600, desc: '2 acres'}, {id: 700, desc: '5 acres'}, {id: 800, desc: '10 acres'}, {id: 900, desc: '15 acres'}, {id: 1000, desc: '20+ acres'}],
      showLotSizes: false,
      homeages: [{id: 1, desc: '1 year'}, {id: 3, desc: '3 years'}, {id: 5, desc: '5 years'}, {id: 10, desc: '10 years'}, {id: 15, desc: '15 years'}, {id: 20, desc: '20 years'}, {id: 30, desc: '30 years'}, {id: 40, desc: '40 years'}, {id: 50, desc: '50+ years'}],
      showHomeAges: false,
      HOAs: [100, 200, 500, 750, 1000, 2000, 3000],
      showHOAPrices: false,
      money: {
        decimal: '.',
        thousands: ',',
        prefix: '$ ',
        suffix: '',
        precision: 0,
        masked: false
      }
    }
  },
  mixins: [mixins],
  components: {
    Money
  },
  computed: {
    ...mapGetters('homeSearch', [
      'getListingStatus',
      'getListingOptions',
      'getListingEvents',
      'getMinSqft',
      'getMaxSqft',
      'getMinLotSize',
      'getMaxLotSize',
      'getMinHOA',
      'getMaxHOA',
      'getInsideFeatures',
      'getOutsideFeatures',
      'getHeatingCooling',
      'getGarage',
      'getParking',
      'getMinHomeAge',
      'getMaxHomeAge',
      'getLotView',
      'getCommunityAmenities',
      'getStories'
    ]),
    listingStatusDefault () {
      return JSON.stringify(this.getListingStatus) === JSON.stringify(['Active'])
    },
    listingStatus: {
      get () {
        return this.getListingStatus
      },
      set (value) {
        // Add additional logic to account for the pairing of pending/contingent statuses
        if (value.includes('Pending') && !value.includes('Contingent')) {
          value.push('Contingent')
        } else if (value.includes('Contingent') && !value.includes('Pending')) {
          value = value.filter(element => element !== 'Contingent')
        }
        this.updateListingStatus(value)
      }
    },
    listingOptions: {
      get () {
        return this.getListingOptions
      },
      set (value) {
        this.updateListingOptions(value)
      }
    },
    listingEvents: {
      get () {
        return this.getListingEvents
      },
      set (value) {
        this.updateListingEvents(value)
      }
    },
    minSqft: {
      get () {
        return this.getMinSqft
      },
      set (value) {
        this.updateMinSqft(value)
      }
    },
    maxSqft: {
      get () {
        return this.getMaxSqft
      },
      set (value) {
        this.updateMaxSqft(value)
      }
    },
    minSqfts () {
      var index = this.sqfts.length
      if (this.getMaxSqft) {
        index = this.sqfts.findIndex((sqft) => {
          return sqft > this.getMaxSqft
        })
      }
      return this.sqfts.slice(0, index)
    },
    maxSqfts () {
      var index = 0
      if (this.getMinSqft) {
        index = this.sqfts.findIndex((sqft) => {
          return sqft > this.getMinSqft
        })
      }
      return this.sqfts.slice(index)
    },
    minLotSize: {
      get () {
        return this.getMinLotSize
      },
      set (value) {
        this.updateMinLotSize(value)
      }
    },
    maxLotSize: {
      get () {
        return this.getMaxLotSize
      },
      set (value) {
        this.updateMaxLotSize(value)
      }
    },
    minLotSizes () {
      var index = this.lotsizes.length
      if (this.getMaxLotSize) {
        index = this.lotsizes.findIndex(lotSize => {
          return lotSize.desc === this.getMaxLotSize
        })
      }
      return this.lotsizes.slice(0, index)
    },
    maxLotSizes () {
      var index = 0
      if (this.getMinLotSize) {
        index = this.lotsizes.findIndex(lotSize => {
          return lotSize.desc === this.getMinLotSize
        })
      }
      return this.lotsizes.slice(index)
    },
    minHOA: {
      get () {
        return this.getMinHOA
      },
      set (value) {
        this.updateMinHOA(value)
      }
    },
    maxHOA: {
      get () {
        return this.getMaxHOA
      },
      set (value) {
        this.updateMaxHOA(value)
      }
    },
    minHOAs () {
      var index = this.HOAs.length
      if (this.getMaxHOA > 0) {
        index = this.HOAs.findIndex((HOA) => {
          return HOA > this.getMaxHOA
        })
      }
      return this.HOAs.slice(0, index)
    },
    maxHOAs () {
      var index = 0
      if (this.getMinHOA) {
        index = this.HOAs.findIndex((HOA) => {
          return HOA > this.getMinHOA
        })
      }
      return this.HOAs.slice(index)
    },
    insideFeatures: {
      get () {
        return this.getInsideFeatures
      },
      set (value) {
        this.updateInsideFeatures(value)
      }
    },
    outsideFeatures: {
      get () {
        return this.getOutsideFeatures
      },
      set (value) {
        this.updateOutsideFeatures(value)
      }
    },
    heatingCooling: {
      get () {
        return this.getHeatingCooling
      },
      set (value) {
        this.updateHeatingCooling(value)
      }
    },
    garage: {
      get () {
        return this.getGarage
      },
      set (value) {
        this.updateGarage(value)
      }
    },
    parking: {
      get () {
        return this.getParking
      },
      set (value) {
        this.updateParking(value)
      }
    },
    minHomeAge: {
      get () {
        return this.getMinHomeAge
      },
      set (value) {
        this.updateMinHomeAge(value)
      }
    },
    maxHomeAge: {
      get () {
        return this.getMaxHomeAge
      },
      set (value) {
        this.updateMaxHomeAge(value)
      }
    },
    minHomeAges () {
      var index = this.homeages.length
      if (this.getMaxHomeAge) {
        index = this.homeages.findIndex(homeAge => {
          return homeAge.id > this.getMaxHomeAge
        })
      }
      return this.homeages.slice(0, index)
    },
    maxHomeAges () {
      var index = 0
      if (this.getMinHomeAge) {
        index = this.homeages.findIndex(homeAge => {
          return homeAge.id > this.getMinHomeAge
        })
      }
      return this.homeages.slice(index)
    },
    lotView: {
      get () {
        return this.getLotView
      },
      set (value) {
        this.updateLotView(value)
      }
    },
    communityAmenities: {
      get () {
        return this.getCommunityAmenities
      },
      set (value) {
        this.updateCommunityAmenities(value)
      }
    },
    stories: {
      get () {
        return this.getStories
      },
      set (value) {
        this.updateStories(value)
      }
    }
  },
  methods: {
    HOAHidden () {
      if (this.getMinHOA >= this.getMaxHOA) this.updateMaxHOA(0)
      if (this.getMinHOA > 3000) this.updateMinHOA(3000)
    },
    ...mapMutations('homeSearch', [
      'updateListingStatus',
      'updateListingOptions',
      'updateListingEvents',
      'updateMinSqft',
      'updateMaxSqft',
      'updateMinLotSize',
      'updateMaxLotSize',
      'updateMinHomeAge',
      'updateMaxHomeAge',
      'updateMinHOA',
      'updateMaxHOA',
      'updateInsideFeatures',
      'updateOutsideFeatures',
      'updateHeatingCooling',
      'updateGarage',
      'updateParking',
      'updateLotView',
      'updateCommunityAmenities',
      'updateStories'
    ])
  }
}
</script>

<style scoped>
.color-box {
  width: 1rem;
  height: 1rem;
  border-radius: 2px;
  margin-left: 0.5rem;
}

.middle-dash {
  padding-right: 5px;
  padding-left: 5px;
  padding-top: .5rem;
  margin-bottom: 0;
}

.HOA-input {
  width: 100% !important;
}

.btn-primary {
  width: auto !important;
}

.dropdown-form /deep/ .dropdown-menu {
  max-height: 100vh;
  overflow-y: auto;
}

.dropdown-form >>> .dropdown-item:hover {
  background-color: rgb(254, 237, 170) !important;
}

.dropdown-form >>> .dropdown-toggle::after {
  display:none;
}

.HOA-select:hover {
  background-color: rgb(254, 237, 170);
}

.right-dropdown-col, .left-dropdown-col {
  padding: 0;
  text-align: left !important;
}

.dropdown-row {
  width: 300px;
}

.no-margin {
  margin: 0;
}

.form-check {
  align-items: left !important;
  justify-content: left !important;
}

.HOA-select {
  border-radius: 30px;
  cursor: pointer;
}

.color-button >>> .btn {
  background-color: #eaeaea !important;
}
</style>



// WEBPACK FOOTER //
// src/components/home/homeSearch/searchBar/buttons/More.vue